// Storage 存储相关的Key名

/** md5 salt */
export const SALT_FOR_USER = 'RAYS_USER_MERGE_20211116_WTDC';

export const BOOLEAN_HEAT_MAP_PERMISSION = 'BOOLEAN_HEAT_MAP_PERMISSION';

export const OBJECT_STORAGE_MOVABLE_INFO = 'OBJECT_STORAGE_MOVABLE_INFO';

export const OBJECT_HEAT_MAP_LOCAL_MOCK_POINT = 'OBJECT_HEAT_MAP_LOCAL_MOCK_POINT';

/** 白天or夜晚 */
export const BOOLEAN_IS_DAYTIME = 'BOOLEAN_IS_DAYTIME';

// 收藏提示 次数
export const NUMBER_COUNT_FOR_COLLECT = 'NUMBER_COUNT_FOR_COLLECT';

//已购点击的菜单
export const COLLECTIONSTATE = 'COLLECTIONSTATE';

// 第一次进入首页，弹出用户画像
export const BOOLEAN_USER_PORTRAIT_ENTERED = 'BOOLEAN_USER_PORTRAIT_ENTERED';
// 是否直接进客服(或先进提示页) 不提示时间记录
export const NUMBER_DIRECT_TO_CUSTOMER = 'NUMBER_DIRECT_TO_CUSTOMER';

//已显示会员活动指引的会员活动id
export const HAD_SHOW_MEMBER_GUIDE = 'HAD_SHOW_MEMBER_GUIDE';

export const SESSION_STORAGE_REFERER_PAGE = 'SESSION_STORAGE_REFERER_PAGE';
